import { render, staticRenderFns } from "./AccountTeams.vue?vue&type=template&id=671da473&scoped=true&"
import script from "./AccountTeams.vue?vue&type=script&lang=ts&"
export * from "./AccountTeams.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671da473",
  null
  
)

export default component.exports